export const DESKTOP_BREAKPOINT = 1024;
export const MOBILE_BREAKPOINT = 360;

export const DESKTOP_TAB_CATEGORY_COUNT = 6;
export const TABLET_TAB_CATEGORY_COUNT = 5;
export const MOBILE_TAB_CATEGORY_COUNT = 0;
